var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"product_image",attrs:{"src":_vm.image,"alt":"product-image"}})}
var staticRenderFns = []

export { render, staticRenderFns }